import script from "./ReferralOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferralOverview.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeuePagination from "@/components/neue/NeuePagination.vue";
import NeueTablist from "@/components/neue/NeueTablist.vue";
import ReportChart from "@/components/reports/ReportChart.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
import TablistGrid from "@/components/neue/TablistGrid.vue";
import TablistHeader from "@/components/neue/TablistHeader.vue";
import TablistRow from "@/components/neue/TablistRow.vue";
script.components = Object.assign({}, { NeueLoading, NeuePagination, NeueTablist, ReportChart, SecondaryNav, SecondaryTop, TablistGrid, TablistHeader, TablistRow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NeueLoading, NeuePagination, NeueTablist, ReportChart, SecondaryNav, SecondaryTop, TablistGrid, TablistHeader, TablistRow }, script.__o.components);}